<template>
    <div>
        <!--导航栏-->
        <van-nav-bar
                title="商户进件"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏-->

        <!--表单 start-->
        <van-form class="form_box" @submit="onSubmit" validate-first @failed="onFailed">


            <!--商户码-->
            <van-cell class="pay_code" title="商户码" :value="form.extData.payCode" size="large"/>
            <!--商户码-->


            <!--需要录入的信息-->
            <van-collapse v-model="activeNames">
                <!--商户入网信息 start-->
                <van-collapse-item title="商户入网信息" icon="shop-o" name="1">
                    <!--商户类型 ok start-->
                    <van-field
                            readonly
                            clickable
                            name="baseInfo.merchantType"
                            :rules="[{ required: true, message: '商户类型必选' }]"
                            :value="merchantTypeValue"
                            label="商户类型"
                            placeholder="点击选择商户类型"
                            @click="showMerchantTypePicker = true"
                    />
                    <van-popup v-model="showMerchantTypePicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="merchantType"
                                default-index="1"
                                @confirm="onMerchantTypeConfirm"
                                @cancel="showMerchantTypePicker = false"
                        />
                    </van-popup>
                    <!--商户类型 end-->

                    <!--商户全称 ok start-->
                    <van-field
                            clearable
                            v-model="form.baseInfo.merchantName"
                            name="baseInfo.merchantName"
                            label="商户全称"
                            type="textarea"
                            autosize
                            maxlength="40"
                            show-word-limit
                            rows="2"
                            placeholder="2-40个字，与营业执照名称一致；若为小微商户，应填“商户_XXX”，XXX为小微商户身份证上的姓名"
                            :rules="[{ required: true, message: '商户全称必须填写' }]"
                    />
                    <!--商户全称 end-->

                    <!--商户简称 ok start-->
                    <van-field
                            maxlength="30"
                            clearable
                            show-word-limit
                            v-model="form.baseInfo.merchantShortName"
                            name="licenseInfo.merchantShortName"
                            label="商户简称"
                            placeholder="商户简称，2~30个字，不能为纯数字，不能包含敏感词汇"
                            :rules="[{ required: true, message: '商户简称必须填写' }]"
                    />
                    <!--商户简称 end-->

                    <!--营业执照证照 ok start-->
                    <van-field name="licenseInfo.licensePic" label="营业执照证照">
                        <template #input>
                            <img class="photo" :src="imgs.licensePic" alt="" @click="openPhoto('licensePic')">
                        </template>
                    </van-field>
                    <!--营业执照证照 end-->

                    <!--营业执照名称 ok start-->
                    <van-field
                            v-model="form.licenseInfo.licenseFullName"
                            name="licenseInfo.licenseFullName"
                            label="营业执照名称"
                            maxlength="40"
                            clearable
                            show-word-limit
                            placeholder="2-40个字，与商户全称一致，若营业执照无商家名称或名称为“*”或“***”，则应填“个体户XXX”，XXX为营业执照上经营者姓名"
                            :rules="[{ required: true, message: '营业执照名称必须填写' }]"
                    />
                    <!--营业执照名称 end-->

                    <!--营业执照编号 ok start-->
                    <van-field
                            v-model="form.licenseInfo.license"
                            name="licenseInfo.license"
                            label="营业执照编号"
                            maxlength="18"
                            clearable
                            show-word-limit
                            placeholder="营业执照注册号"
                            :rules="[{ required: true, message: '营业执照注册号必须填写' }]"
                    />
                    <!--营业执照编号 end-->

                    <!--营业执照地址 ok start-->
                    <van-field
                            v-model="form.licenseInfo.licenseAddress"
                            name="licenseInfo.licenseAddress"
                            label="营业执照地址"
                            clearable
                            show-word-limit
                            placeholder="营业执照地址"
                            :rules="[{ required: true, message: '营业执照地址必须填写' }]"
                    />
                    <!--营业执照地址 end-->

                    <!--营业执照有效期 ok start-->
                    <van-field
                            readonly
                            clickable
                            name="licenseInfo.licenseStart"
                            :value="form.licenseInfo.licenseStart"
                            label="证件开始时间"
                            placeholder="点击选择证件开始时间"
                            @click="showLicenseStartPicker = true"
                    />
                    <van-popup v-model="showLicenseStartPicker" position="bottom">
                        <van-datetime-picker
                                type="date"

                                @confirm="onLicenseStartConfirm"
                                @cancel="showLicenseStartPicker = false"
                        />
                    </van-popup>
                    <van-row>
                        <van-col span="18">
                            <van-field
                                    readonly
                                    clickable
                                    name="licenseInfo.licenseEnd"
                                    :value="form.licenseInfo.licenseEnd"
                                    label="证件结束时间"
                                    placeholder="点击选择证件结束时间"
                                    @click="showLicenseEndPickerClick()"
                            />

                            <van-popup v-model="showLicenseEndPicker" position="bottom">
                                <van-datetime-picker
                                        type="date"
                                        :max-date="maxDate"
                                        :disabled="showLicenseEndPicker"
                                        style="padding-top: 10px"
                                        @confirm="onLicenseEndConfirm"
                                        @cancel="showLicenseEndPicker = false"
                                />
                            </van-popup>

                        </van-col>
                        <van-col span="6" style="padding-top: 12px;">
                            <van-checkbox v-model="isLicenseEnd">长期</van-checkbox>
                        </van-col>
                    </van-row>
                    <!--营业执照有效期 end-->


                    <!--法人证件类型 ok start-->
                    <van-field
                            readonly
                            clickable
                            name="legalPerson.credentialType"
                            :rules="[{ required: true, message: '法人证件类型必选' }]"
                            :value="data.legalPerson.credentialType"
                            label="法人证件类型"
                            placeholder="点击选择法人证件类型"
                            @click="showCredentialTypePicker = true"
                    />
                    <van-popup v-model="showCredentialTypePicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="credentialType"
                                @confirm="onCredentialTypeConfirm"
                                @cancel="showCredentialTypePicker = false"
                        />
                    </van-popup>
                    <!--法人证件类型 end-->

                    <!--法人证件照 ok start-->
                    <!--法人证件照人像面-->
                    <van-field name="legalPerson.idcardFrontPic" label="法人证件照人像面">
                        <template #input>
                            <img class="photo" :src="imgs.idcardFrontPic" alt="" @click="openPhoto('idcardFrontPic')">
                        </template>
                    </van-field>
                    <!--法人证件照人像面-->

                    <!--法人证件照国徽面-->
                    <van-field name="legalPerson.idcardBackPic" label="法人证件照国徽面">
                        <template #input>
                            <img class="photo" :src="imgs.idcardBackPic" alt="" @click="openPhoto('idcardBackPic')">
                        </template>
                    </van-field>
                    <!--法人证件照国徽面-->
                    <!--法人证件照 end-->

                    <!--法人姓名 ok start-->
                    <van-field
                            :rules="[{ required: true, message: '法人姓名必须填写' }]"
                            maxlength="10"
                            clearable
                            show-word-limit
                            v-model="form.legalPerson.legalName"
                            name="legalPerson.legalName"
                            label="法人姓名"
                            placeholder="法人姓名"
                    />
                    <!--法人姓名 end-->

                    <!--法人证件号 ok start-->
                    <van-field
                            :rules="[{ required: true, message: '法人证件号必须填写' }]"
                            maxlength="18"
                            clearable
                            show-word-limit
                            v-model="form.legalPerson.idCardNo"
                            name="legalPerson.idCardNo"
                            label="法人证件号"
                            placeholder="法人证件号"
                    />
                    <!--法人证件号 end-->

                    <!--证件有效期 start-->

                    <!--开始时间-->
                    <van-field
                            readonly
                            clickable
                            name="legalPerson.idCardStart"
                            :value="form.legalPerson.idCardStart"
                            label="证件开始时间"
                            placeholder="点击证件开始时间"
                            @click="showIdCardStartPicker = true"
                    />
                    <van-popup v-model="showIdCardStartPicker" position="bottom">
                        <van-datetime-picker
                                type="date"
                                @confirm="onIdCardStartConfirm"
                                @cancel="showIdCardStartPicker = false"
                        />
                    </van-popup>
                    <!--开始时间-->
                    <!--结束时间-->
                    <van-row>
                        <van-col span="18">
                            <van-field
                                    clickable
                                    readonly
                                    :disabled="showIdCardEndPicker"
                                    name="legalPerson.idCardEnd"
                                    :value="form.legalPerson.idCardEnd"
                                    label="证件结束时间"
                                    placeholder="点击证件结束时间"
                                    @click="showIdCardEndPickerClick()"
                            />

                            <van-popup v-model="showIdCardEndPicker" position="bottom">
                                <van-datetime-picker
                                        type="date"
                                        :max-date="maxDate"
                                        style="padding-top: 10px"
                                        @confirm="onIdCardEndConfirm"
                                        @cancel="showIdCardEndPicker = false"
                                />
                            </van-popup>

                        </van-col>
                        <van-col span="6" style="padding-top: 12px;">

                            <van-checkbox v-model="isIdCardEnd">长期</van-checkbox>
                        </van-col>
                    </van-row>
                    <!--结束时间-->


                    <!--证件有效期 end-->

                    <!--行业类型 start-->

                    <van-field
                            readonly
                            clickable
                            name="baseInfo.mccCode"
                            :rules="[{ required: true, message: '行业类型必选' }]"
                            :value="form.baseInfo.mccCode"
                            label="行业类型"
                            placeholder="点击选择行业类型"
                            @click="showMccCodePicker = true"
                    />
                    <van-popup v-model="showMccCodePicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="LeshuazfMcc"
                                @confirm="onMccCodeConfirm"
                                @cancel="showMccCodePicker = false"
                        />
                    </van-popup>
                    <!--行业类型 end-->

                    <!--经营地址 start-->
                    <van-field
                            readonly
                            clickable
                            name="addressInfo.provinceCode_cityCode_areaCode"
                            :rules="[{ required: true, message: '省区县必选' }]"
                            :value="form.addressInfo.provinceCode_cityCode_areaCode"
                            label="经营地址省区县"
                            placeholder="点击选经营地址省区县"
                            @click="showAddressPicker = true"
                    />
                    <van-popup v-model="showAddressPicker" position="bottom">

                        <van-area :area-list="LeshuazfArea" @confirm="onAddressConfirm"
                                  @cancel="showAddressPicker = false" :columns-num="3" title="省区县"/>

                    </van-popup>
                    <van-field
                            v-model="form.addressInfo.address"
                            name="addressInfo.address"
                            label="详细地址"
                            placeholder="详细地址需超过5个字，详细到门牌号"
                    />

                    <!--经营地址 end-->

                    <!--客服电话 start-->
                    <van-field
                            v-model="form.baseInfo.servicePhone"
                            name="baseInfo.servicePhone"
                            label="客服电话"
                            :rules="[{ required: true, message: '客服电话必须填写' }]"
                            placeholder="用于联系商家客服，不填默认为商户账号信息填写手机号"
                    />
                    <!--客服电话 end-->


                </van-collapse-item>
                <!--商户入网信息 end-->
                <!--商户结算信息 start-->
                <van-collapse-item title="商户结算信息" icon="shop-o" name="2">
                    <!--结算对象 ok start-->
                    <van-field
                            readonly
                            clickable
                            name="shopInfo.settleTo"
                            :rules="[{ required: true, message: '结算对象类型必选' }]"
                            :value="settleToValue"
                            label="结算对象"
                            placeholder="点击选择结算对象"
                            @click="showSettleToPicker = true"
                    />
                    <van-popup v-model="showSettleToPicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="settleTo"
                                @confirm="onSettleToConfirm"
                                @cancel="showSettleToPicker = false"
                        />
                    </van-popup>
                    <!--结算对象 end-->

                    <!--结算账户类型 ok start-->
                    <van-field
                            readonly
                            clickable
                            name="accountInfo.type"
                            :rules="[{ required: true, message: '结算账户类型必选' }]"
                            :value="typeValue"
                            label="结算账户类型"
                            placeholder="点击选择结算账户类型"
                            @click="showTypePicker = true"
                    />
                    <van-popup v-model="showTypePicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="type"
                                @confirm="onTypeConfirm"
                                @cancel="showTypePicker = false"
                        />
                    </van-popup>
                    <!--结算账户类型 end-->

                    <!--结算类型 ok start-->
                    <van-field
                            readonly
                            clickable
                            name="accountInfo.legalFlag"
                            :rules="[{ required: true, message: '结算类型必选' }]"
                            :value="legalFlagValue"
                            label="结算类型"
                            placeholder="点击选择结算类型"
                            @click="showLegalFlagPicker = true"
                    />
                    <van-popup v-model="showLegalFlagPicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="legalFlag"
                                default-index="1"
                                @confirm="onLegalFlagConfirm"
                                @cancel="showLegalFlagPicker = false"
                        />
                    </van-popup>
                    <!--结算类型 end-->
                    <!--非法人结算 start-->
                    <!--非法人授权书-->
                    <van-field v-if="form.accountInfo.legalFlag==0" name="accountInfo.nonLegSettleAuthPic"
                               label="非法人授权书" :value="form.accountInfo.nonLegSettleAuthPic"
                               :rules="[{ required: true, message: '非法人授权书必选传' }]">
                        <template #input>
                            <img class="photo" :src="imgs.nonLegSettleAuthPic" alt=""
                                 @click="openPhoto('nonLegSettleAuthPic')">
                        </template>
                    </van-field>
                    <!--非法人授权书-->
                    <!--非法人证件照-->
                    <!--身份证人面-->
                    <van-field v-if="form.accountInfo.legalFlag==0" name="accountInfo.nonLegIdcardFrontPic"
                               label="非法人身份证人面" :value="form.accountInfo.nonLegIdcardFrontPic"
                               :rules="[{ required: true, message: '非法人身份证人面必选传' }]">
                        <template #input>
                            <img class="photo" :src="imgs.nonLegIdcardFrontPic" alt=""
                                 @click="openPhoto('nonLegIdcardFrontPic')">
                        </template>
                    </van-field>
                    <!--身份证人面-->
                    <!--身份证国徽面-->
                    <van-field v-if="form.accountInfo.legalFlag==0" name="accountInfo.nonLegIdcardBackPic"
                               label="非法人身份证国徽面" :value="form.accountInfo.nonLegIdcardBackPic"
                               :rules="[{ required: true, message: '非法人身份证国徽必选传' }]">
                        <template #input>
                            <img class="photo" :src="imgs.nonLegIdcardBackPic" alt=""
                                 @click="openPhoto('nonLegIdcardBackPic')">
                        </template>
                    </van-field>
                    <!--身份证国徽面-->
                    <!--非法人证件照-->

                    <!--非法人结算 end-->

                    <!--银行卡照片/开户许可证 ok start-->
                    <van-field name="accountInfo.bankCardFrontPic" :label="bankCardFrontPicLable">
                        <template #input>
                            <img class="photo" :src="imgs.bankCardFrontPic" alt=""
                                 @click="openPhoto('bankCardFrontPic')">
                        </template>
                    </van-field>
                    <!--银行卡照片/开户许可证 end-->

                    <!--法人手持证件照 start-->
                    <van-field name="extData.imgs.merchant_img_legal_holding_id_photo" label="法人手持证件照">
                        <template #input>
                            <img class="photo" :src="imgs.merchant_img_legal_holding_id_photo" alt=""
                                 @click="openPhoto('merchant_img_legal_holding_id_photo')">
                        </template>
                    </van-field>
                    <!--法人手持证件照 end-->


                    <!--负责人手持银行卡 start-->
                    <van-field name="extData.imgs.merchant_img_holding_bank_card" label="负责人手持银行卡">
                        <template #input>
                            <img class="photo" :src="imgs.merchant_img_holding_bank_card" alt=""
                                 @click="openPhoto('merchant_img_holding_bank_card')">
                        </template>
                    </van-field>
                    <!--负责人手持银行卡 end-->


                    <!--负责人身份证正面 start-->
                    <van-field name="extData.imgs.merchant_img_principal_id_card_front" label="负责人身份证正面">
                        <template #input>
                            <img class="photo" :src="imgs.merchant_img_principal_id_card_front" alt=""
                                 @click="openPhoto('merchant_img_principal_id_card_front')">
                        </template>
                    </van-field>
                    <!--负责人身份证正面 end-->


                    <!--负责人身份证反面 start-->
                    <van-field name="extData.imgs.merchant_img_principal_id_card_obverse" label="负责人身份证反面">
                        <template #input>
                            <img class="photo" :src="imgs.merchant_img_principal_id_card_obverse" alt=""
                                 @click="openPhoto('merchant_img_principal_id_card_obverse')">
                        </template>
                    </van-field>
                    <!--负责人身份证反面 end-->


                    <!--负责人手持证件照 start-->
                    <van-field name="extData.imgs.merchant_img_holding_photo" label="负责人手持证件照">
                        <template #input>
                            <img class="photo" :src="imgs.merchant_img_holding_photo" alt=""
                                 @click="openPhoto('merchant_img_holding_photo')">
                        </template>
                    </van-field>
                    <!--负责人手持证件照 end-->


                    <!--开户名 ok start-->
                    <van-field
                            maxlength="30"
                            clearable
                            show-word-limit
                            v-model="form.accountInfo.holder"
                            name="accountInfo.holder"
                            label="开户名"
                            placeholder="个人结算写姓名，公户填写营业执照名称"
                            :rules="[{ required: true, message: '开户名必须填写' }]"
                    />
                    <!--开户名 end-->

                    <!--开户号 ok start-->
                    <van-field
                            maxlength="30"
                            clearable
                            show-word-limit
                            v-model="form.accountInfo.bankCardNo"
                            name="accountInfo.bankCardNo"
                            label="开户号"
                            placeholder="请填写开户号"
                            :rules="[{ required: true, message: '开户号必须填写' }]"
                    />
                    <!--开户号 end-->

                    <!--结算人证件号 ok start-->
                    <van-field
                            v-if="form.accountInfo.type==1"
                            maxlength="30"
                            clearable
                            show-word-limit
                            v-model="form.accountInfo.idCardNo"
                            name="accountInfo.idCardNo"
                            label="结算人证件号"
                            placeholder="请填写结算人证件号"
                            :rules="[{ required: true, message: '结算人证件号必须填写' }]"
                    />
                    <!--结算人证件号 end-->

                    <!--银行网点-省 start-->
                    <van-field
                            readonly
                            clickable
                            :rules="[{ required: true, message: '银行网点-省' }]"
                            :value="provinceBanksVal"
                            label="银行网点-省"
                            placeholder="点击选择银行网点-省"
                            @click="showProvinceBanksPicker = true"
                    />
                    <van-popup v-model="showProvinceBanksPicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="provinceBanks"
                                @confirm="onProvinceBanksConfirm"
                                @cancel="showLegalFlagPicker = false"
                        />
                    </van-popup>
                    <!--银行网点省 end-->
                    <!--银行网点市 start-->
                    <van-field
                            readonly
                            clickable
                            :rules="[{ required: true, message: '银行网点-市' }]"
                            :value="cityBanksVal"
                            label="银行网点-市"
                            placeholder="点击选择银行网点-市"
                            @click="showCityBanksPicker = true"
                    />
                    <van-popup v-model="showCityBanksPicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="cityBanks"
                                @confirm="onCityBanksConfirm"
                                @cancel="showCityBanksPicker = false"
                        />
                    </van-popup>
                    <!--银行网点市 end-->
                    <!--银行分行网点 start-->
                    <van-field
                            readonly
                            clickable
                            name="accountInfo.unionpay"
                            :rules="[{ required: true, message: '银行分行网点必填' }]"
                            :value="banksVal"
                            label="银行分行网点"
                            placeholder="模糊搜索银行分行网点"
                            @click="showBanksPicker = true"
                    />
                    <van-popup round v-model="showBanksPicker" position="bottom" :style="{ height: '80%' }">
                        <van-search v-model="banksValue" placeholder="请输入银行关键词"/>
                        <van-cell @click="banksSelected(item)" clickable v-bind:key="key"
                                  v-for="(item,key) in banksData" :value="item.address"/>
                    </van-popup>
                    <!--银行分行网点 end-->



                    <!--银行预留手机号 ok start-->
                    <van-field
                            maxlength="11"
                            clearable
                            show-word-limit
                            v-model="form.extData.settlement_bank_tel"
                            name="extData.settlement_bank_tel"
                            label="银行预留手机号"
                            placeholder="请填银行预留手机号"
                            :rules="[{ required: true, message: '请填银行预留手机号' }]"
                    />
                    <!--银行预留手机号 end-->


                    <!--T0费率 ok start-->
                    <van-field
                            maxlength="30"
                            clearable
                            show-word-limit
                            v-model="form.extData.merchant_t0_rate"
                            name="extData.merchant_t0_rate"
                            label="T0费率"
                            placeholder="请填T0费率"
                            :rules="[{ required: true, message: 'T0费率必须填写' }]"
                    />
                    <!--T0费率 end-->


                    <!--T1费率 ok start-->
                    <van-field
                            maxlength="30"
                            clearable
                            show-word-limit
                            v-model="form.extData.merchant_t1_rate"
                            name="extData.merchant_t1_rate"
                            label="T1费率"
                            placeholder="请填T1费率"
                            :rules="[{ required: true, message: 'T1费率必须填写' }]"
                    />
                    <!--T1费率 end-->

                    <!--D0费率 ok start-->
                    <van-field
                            maxlength="30"
                            clearable
                            show-word-limit
                            v-model="form.extData.merchant_d0_rate"
                            name="extData.merchant_d0_rate"
                            label="D0费率"
                            placeholder="请填D0费率"
                            :rules="[{ required: true, message: 'D0费率必须填写' }]"
                    />
                    <!--D0费率 end-->

                    <!--D1费率 ok start-->
                    <van-field
                            maxlength="30"
                            clearable
                            show-word-limit
                            v-model="form.extData.merchant_d1_rate"
                            name="extData.merchant_d1_rate"
                            label="D1费率"
                            placeholder="请填D1费率"
                            :rules="[{ required: true, message: 'D1费率必须填写' }]"
                    />
                    <!--D1费率 end-->



                </van-collapse-item>
                <!--商户结算信息 end-->
                <!--证照信息 start-->
                <van-collapse-item title="证照信息" icon="shop-o" name="3">
                    <!--门头照 ok start-->
                    <van-field name="shopInfo.doorPic" label="门头照">
                        <template #input>
                            <img class="photo" :src="imgs.doorPic" alt="" @click="openPhoto('doorPic')">
                        </template>
                    </van-field>
                    <!--门头照 end-->

                    <!--收银台照 ok start-->
                    <van-field name="shopInfo.cashierDeskPic" label="收银台照">
                        <template #input>
                            <img class="photo" :src="imgs.cashierDeskPic" alt="" @click="openPhoto('cashierDeskPic')">
                        </template>
                    </van-field>
                    <!--收银台照 end-->

                    <!--经营场所照 ok start-->
                    <van-field name="shopInfo.insidePic" label="经营场所照">
                        <template #input>
                            <img class="photo" :src="imgs.insidePic" alt="" @click="openPhoto('insidePic')">
                        </template>
                    </van-field>
                    <!--经营场所照 end-->

                </van-collapse-item>
                <!--证照信息 end-->
            </van-collapse>
            <!--需要录入的信息-->

            <!--提交按钮-->
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                    提交
                </van-button>
            </div>
            <!--提交按钮-->
        </van-form>
        <!--表单 end-->

    </div>
</template>

<script>
    import LeshuazfArea from '@/assets/json/leshuazf_area'
    import LeshuazfMcc from '@/assets/json/leshuazf_mcc'
    import {Notify, Toast, Dialog} from 'vant';
    import VueCookie from 'vue-cookies'
    import wx from 'weixin-js-sdk'
    import phone_upload_img from '@/assets/images/phone_upload.png'
    import Config from '@/config'

    //商户添加
    export default {
        name: "MerchantAdd",
        data() {
            return {
                //最大日期
                maxDate: new Date(2099, 12, 31),
                //收缩
                activeNames: ['1'],
                //商户类型
                merchantType: [],
                //是否显示商户类型选择
                showMerchantTypePicker: false,
                //证件类型
                credentialType: [],
                //是否显示证件类型选择
                showCredentialTypePicker: false,
                //是否显示商户经营地址选择
                showAddressPicker: false,
                //结算对象数据
                settleTo: [],
                //结算对象选择
                showSettleToPicker: false,
                //结算账户类型
                type: [],
                //结算账户类型
                showTypePicker: false,
                //结算类型
                legalFlag: [],
                //结算类型选择
                showLegalFlagPicker: false,
                //法人证件开始时间选择
                showIdCardStartPicker: false,
                //法人证件结束时间选择
                showIdCardEndPicker: false,
                //法人证件是否是长期
                isIdCardEnd: false,
                //营业执照是否是长期
                isLicenseEnd: false,
                //显示MCC码
                showMccCodePicker: false,
                //营业执照开始日期选择
                showLicenseStartPicker: false,
                //营业执照结束日期选择
                showLicenseEndPicker: false,
                //银行网点省
                showProvinceBanksPicker: false,
                //银行网点市
                showCityBanksPicker: false,
                //银行网点
                showBanksPicker: false,
                merchantTypeValue: '',
                legalFlagValue: '',
                typeValue: "",
                settleToValue: "",
                LeshuazfArea: LeshuazfArea,
                LeshuazfMcc: LeshuazfMcc,
                //银行网点省
                provinceBanks: [],
                //银行网点市
                cityBanks: [],
                //银行网点省值
                provinceBanksVal: "",
                //银行网点市值
                cityBanksVal: "",
                //输入框银行文字
                banksVal: "",
                //银行名称
                banksValue: '',
                bankCardFrontPicLable: "银行卡照片",
                //模糊查询银行列表数据
                banksData: [],
                //接收数据
                data: {
                    baseInfo: {
                        merchantType: "企业"
                    },
                    legalPerson: {
                        credentialType: "身份证"
                    }
                },
                //照片资料
                imgs: {
                    //法人身份证正面
                    idcardFrontPic: phone_upload_img,
                    //法人身份证反面
                    idcardBackPic: phone_upload_img,
                    //手持身份证照
                    idcardHandPic: phone_upload_img,
                    //营业执照
                    licensePic: phone_upload_img,
                    //银行卡正面
                    bankCardFrontPic: phone_upload_img,
                    //非法人结算授权书
                    nonLegSettleAuthPic: phone_upload_img,
                    //非法人身份证正面
                    nonLegIdcardFrontPic: phone_upload_img,
                    //非法人身份证背面
                    nonLegIdcardBackPic: phone_upload_img,
                    //经营场所内设照片
                    insidePic: phone_upload_img,
                    //门头照
                    doorPic: phone_upload_img,
                    //收银台照片
                    cashierDeskPic: phone_upload_img,
                    //商户协议照
                    agreementPic: phone_upload_img,
                    //法人手持证件照
                    merchant_img_legal_holding_id_photo:phone_upload_img,
                    //负责人手持银行卡
                    merchant_img_holding_bank_card:phone_upload_img,
                    //负责人身份证正面
                    merchant_img_principal_id_card_front:phone_upload_img,
                    //负责人身份正反面
                    merchant_img_principal_id_card_obverse:phone_upload_img,
                    //负责人手持证件照
                    merchant_img_holding_photo:phone_upload_img,

                },
                //表单
                form: {
                    "baseInfo": {
                        "mccCode": "",
                        "merchantShortName": "",
                        "servicePhone": "",
                        "merchantType": '',
                        "merchantName": ""
                    },
                    "accountInfo": {
                        "idCardType": 1,
                        "nonLegIdcardFrontPic": "",
                        "legalFlag": '',
                        "bankCardNo": "",
                        "idCardNo": "",
                        "mobile": "",
                        "unionpay": "",
                        "holder": "",
                        "bankCardFrontPic": '',
                        "nonLegSettleAuthPic": '',
                        "type": '',
                        "nonLegIdcardBackPic": ""
                    },
                    "addressInfo": {
                        //区县
                        "areaCode": "",
                        "address": "",
                        //商户所在省
                        "provinceCode": "",
                        //市
                        "cityCode": "",
                        "provinceCode_cityCode_areaCode": ''
                    },
                    "otherInfo": {
                        "agreementPic": "",
                        "auditCallback": "",
                        "reportConfigId": "",
                        "notifyAddress": ""
                    },
                    "shopInfo": {
                        "insidePic": '',
                        "cashierDeskPic": '',
                        "settleTo": '',
                        "doorPic": '',
                        "headMerchantId": "",
                        "shopType": 1
                    },
                    "contactInfo": {
                        "name": "",
                        "mobile": ""
                    },
                    "legalPerson": {
                        "legalName": "",
                        "credentialType": '',
                        "idCardEnd": "",
                        "idcardBackPic": '',
                        "idCardNo": "",
                        "idcardFrontPic": '',
                        "idCardStart": ""
                    },
                    "licenseInfo": {
                        "license": "",
                        "licenseFullName": "",
                        "licenseAddress": "",
                        "licenseStart": "",
                        "licenseEnd": "",
                        "licensePic": ''
                    },
                    "extData": {
                        "payCode": "",
                        "openid": "",
                        "salesman_id":"",
                        //银行预留手机号
                        "settlement_bank_tel":"",
                        "merchant_t0_rate":"",
                        "merchant_t1_rate":"",
                        "merchant_d0_rate":"",
                        "merchant_d1_rate":"",
                        "img": {
                            'merchant_img_electronic_business_license': '',
                            'merchant_img_permit_for_bank_account': '',
                            'merchant_img_corporate_id_card_front': '',
                            'merchant_img_corporate_id_card_obverse': '',
                            'merchant_img_legal_holding_id_photo': '',
                            'merchant_img_principal_id_card_front': '',
                            'merchant_img_principal_id_card_obverse': '',
                            'merchant_img_holding_photo': '',
                            'merchant_img_holding_bank_card': '',
                            'merchant_img_bank_card': '',
                            'merchant_img_door_shot': '',
                            'merchant_img_shop_interior': '',
                            'merchant_img_checkout_counter': '',
                            'merchant_img_authorization_statement': '',
                            'merchant_img_information_form': '',
                            'merchant_img_agreement': '',
                        }
                    }
                }
            }
        },
        methods: {
            //提交商户数据
            onSubmit() {
                console.log('form', this.form);
                this.$http.get('/wechat/api.merchant/addMerchant', {
                    params: this.form
                }).then(function (response) {
                    console.log('response', response);
                    if (response && response.data.code == 200) {
                        Toast.success('进件成功');
                    } else {
                        Dialog.alert({
                            title: '温馨提示',
                            message: response.data.msg
                        }).then(() => {
                            // on close
                        });
                    }

                });
            },
            onFailed(errorInfo) {
                console.log('failed', errorInfo);
            },
            //商户类型选择确定
            onMerchantTypeConfirm(value) {
                console.log('value', value);
                this.form.baseInfo.merchantType = value.value;
                this.merchantTypeValue = value.text;
                this.showMerchantTypePicker = false;
            },
            onCredentialTypeConfirm(value) {
                this.form.legalPerson.credentialType = value.value;
                this.data.legalPerson.credentialType = value.text
                this.showCredentialTypePicker = false;
            },
            onAddressConfirm(value) {
                console.log('value', value);
                this.form.addressInfo.provinceCode_cityCode_areaCode = value.map((item) => item.name).join('/');
                this.form.addressInfo.provinceCode = value[0].code;
                this.form.addressInfo.cityCode = value[1].code;
                this.form.addressInfo.areaCode = value[2].code;
                this.showAddressPicker = false;
            },
            onIdCardStartConfirm(value) {
                this.form.legalPerson.idCardStart = this.dateFormatter(value);
                this.showIdCardStartPicker = false;
            },
            onIdCardEndConfirm(value) {
                this.form.legalPerson.idCardEnd = this.dateFormatter(value);
                this.showIdCardEndPicker = false;
            },
            //结算对象确认
            onSettleToConfirm(value) {
                this.form.shopInfo.settleTo = value.value;
                this.settleToValue = value.text;
                this.showSettleToPicker = false;
            },
            //结算账户类型
            onTypeConfirm(value) {
                this.form.accountInfo.type = value.value;
                this.typeValue = value.text;
                this.showTypePicker = false;
                //对公转账 文字变开户许可照片
                if (value.value == "2") {
                    this.bankCardFrontPicLable = "开户许可证照片"
                }
            },
            //结算账户方式
            onLegalFlagConfirm(value) {
                this.form.accountInfo.legalFlag = value.value;
                this.legalFlagValue = value.text;
                this.showLegalFlagPicker = false;
            },
            //营业执照注册号开始日期(企业必填)格式：2015-09-22
            onLicenseStartConfirm(value) {
                this.form.licenseInfo.licenseStart = this.dateFormatter(value);
                this.showLicenseStartPicker = false;
            },
            //营业执照注册结束日期(企业必填)格式：2015-09-22，永久有效:长期
            onLicenseEndConfirm(value) {
                this.form.licenseInfo.licenseEnd = this.dateFormatter(value);
                this.showLicenseEndPicker = false;
            },
            //银行网点省
            onProvinceBanksConfirm(value) {
                console.log('value', value);
                this.provinceBanksVal = value;
                this.showProvinceBanksPicker = false;
                this.cityBanksVal = "";
                this.getProvinceBanks(2, value);
            },
            //银行网点市
            onCityBanksConfirm(value) {
                console.log('value', value);
                this.cityBanksVal = value;
                this.showCityBanksPicker = false;
                this.getProvinceBanks(3, value);
            },

            onMccCodeConfirm(value) {
                this.form.baseInfo.mccCode = value;
                this.showMccCodePicker = false;
            },
            dateFormatter(date) {
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
                return Y + M + D;
            },
            uploader() {

            },
            //文件读取之后
            afterRead(file, name) {
                // 此时可以自行将文件上传至服务器
                console.log(file);
                console.log(name);
                var formData = new FormData();
                formData.append("file", file.file);
                formData.append("type", name.name);
                this.$http
                    .post("/wechat/api.merchant/uploadMerchantImg", formData, {
                        headers: {"Content-Type": "multipart/form-data"}
                    })
                    .then(
                        function (res) {
                            console.log('res', res);

                            switch (name.name) {
                                case 'doorPic':
                                    this.form.shopInfo[name.name] = res.data.path;
                                    //更改本地图片地址(门头照)
                                    this.form.extData.img.merchant_img_door_shot = res.data.local_img;
                                    break;
                                case 'insidePic':
                                    this.form.shopInfo[name.name] = res.data.path;
                                    //更改本地图片地址(室内景)
                                    this.form.extData.img.merchant_img_shop_interior = res.data.local_img;
                                    break;
                                case 'cashierDeskPic':
                                    this.form.shopInfo[name.name] = res.data.path;
                                    //更改本地图片地址(收银台)
                                    this.form.extData.img.merchant_img_checkout_counter = res.data.local_img;
                                    break;
                                case 'nonLegSettleAuthPic':
                                    //结算授权申请书
                                    this.form.accountInfo.nonLegSettleAuthPic = res.data.path;
                                    //更改本地图片地址(结算授权书)
                                    this.form.extData.img.merchant_img_authorization_statement = res.data.local_img;
                                    break;
                                case 'nonLegIdcardFrontPic':
                                    //非法人身份证人像面
                                    this.form.accountInfo.nonLegIdcardFrontPic = res.data.path;
                                    //更改本地图片地址(负责人正面)
                                    this.form.extData.img.merchant_img_principal_id_card_front = res.data.local_img;
                                    break;
                                case 'nonLegIdcardBackPic':
                                    //非法人身份证国徽面
                                    this.form.accountInfo.nonLegIdcardBackPic = res.data.path;
                                    //更改本地图片地址(负责人反面)
                                    this.form.extData.img.merchant_img_principal_id_card_obverse = res.data.local_img;
                                    break;
                            }


                        },
                        function (res) {
                            console.log(res.body);
                        }
                    );
            },
            //营业执照上传及识别
            licensePicAfterRead(file) {


                // 此时可以自行将文件上传至服务器
                var formData = new FormData();
                formData.append("file", file.file);
                formData.append("type", 'licensePic');
                var toast = Toast.loading({
                    duration: 0,
                    message: '处理中',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$http
                    .post("/wechat/api.merchant/uploadMerchantImg", formData, {
                        headers: {"Content-Type": "multipart/form-data"}
                    })
                    .then(
                        function (res) {
                            console.log('res', res);
                            if (res && res.data.code == 200) {
                                toast.clear();
                                Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});

                                //商户全称
                                this.form.baseInfo.merchantName = res.data.data.name;
                                //营业执照名称
                                this.form.licenseInfo.licenseFullName = res.data.data.name;
                                //营业执照编号
                                this.form.licenseInfo.license = res.data.data.reg_num;
                                //营业执照地址
                                this.form.licenseInfo.licenseAddress = res.data.data.address;
                                //开始日期
                                this.form.licenseInfo.licenseStart = this.dateFormat(res.data.data.establish_date);
                                //营业执照图片赋值
                                this.form.licenseInfo.licensePic = res.data.path;

                                //更改本地图片地址
                                this.form.extData.img.merchant_img_electronic_business_license = res.data.local_img;

                                var licenseEnd = this.dateFormat(res.data.data.valid_period);
                                if (licenseEnd == "2999-12-31") {
                                    //结束日期
                                    this.form.licenseInfo.licenseEnd = '长期';
                                    //选中长期按钮
                                    this.isLicenseEnd = true;
                                } else {
                                    //结束日期
                                    this.form.licenseInfo.licenseEnd = licenseEnd;
                                }

                            }

                        },
                        function (res) {
                            toast.clear();
                            Notify({type: 'primary', message: res.data.msg});
                        }
                    );
            },
            //身份证正面上传及识别
            idcardFrontPicAfterRead(file) {
                var formData = new FormData();
                formData.append("file", file.file);
                formData.append("type", 'idcardFrontPic');
                var toast = Toast.loading({
                    duration: 0,
                    message: '处理中',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$http
                    .post("/wechat/api.merchant/uploadMerchantImg", formData, {
                        headers: {"Content-Type": "multipart/form-data"}
                    })
                    .then(
                        function (res) {
                            console.log('res', res);
                            if (res && res.data.code == 200) {

                                //法人姓名
                                this.form.legalPerson.legalName = res.data.data.name;
                                //联系人为法人
                                this.form.contactInfo.name = res.data.data.name;
                                //法人证件号
                                this.form.legalPerson.idCardNo = res.data.data.num;
                                //法人身份证正面地址
                                this.form.legalPerson.idcardFrontPic = res.data.path;

                                //更改本地图片地址(法人身份证正面)
                                this.form.extData.img.merchant_img_corporate_id_card_front = res.data.local_img;

                                //更改本地图片地址
                                this.form.extData.img.merchant_img_electronic_business_license = res.data.local_img;

                                toast.clear();
                                Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});

                            }

                        },
                        function (res) {
                            toast.clear();
                            Notify({type: 'primary', message: res.data.msg});
                        }
                    );
            },
            //身份证反面上传及识别
            idcardBackPicAfterRead(file) {
                var formData = new FormData();
                formData.append("file", file.file);
                formData.append("type", 'idcardBackPic');
                var toast = Toast.loading({
                    duration: 0,
                    message: '处理中',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$http
                    .post("/wechat/api.merchant/uploadMerchantImg", formData, {
                        headers: {"Content-Type": "multipart/form-data"}
                    })
                    .then(
                        function (res) {
                            console.log('res', res);
                            if (res && res.data.code == 200) {
                                // 身份证开始日期
                                this.form.legalPerson.idCardStart = this.dateFormat(res.data.data.start_date);
                                //身份证结束日期
                                const idCardEndData = this.dateFormat(res.data.data.end_date);
                                //法人身份证正面地址
                                this.form.legalPerson.idcardBackPic = res.data.path;

                                //更改本地图片地址(法人身份证反面)
                                this.form.extData.img.merchant_img_corporate_id_card_obverse = res.data.local_img;

                                if (idCardEndData == "长期") {
                                    //选中长期按钮
                                    this.isIdCardEnd = true;
                                    console.log("isIdCardEnd", this.isIdCardEnd);
                                }
                                // 身份证结束日期
                                this.form.legalPerson.idCardEnd = this.dateFormat(res.data.data.end_date);
                                //toast删除和提示
                                toast.clear();
                                Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});
                            }
                        },
                        function (res) {
                            toast.clear();
                            Notify({type: 'primary', message: res.data.msg});
                        }
                    );
            },
            //银行卡正面上传及识别
            bankCardFrontPicAfterRead(file) {
                var formData = new FormData();
                formData.append("file", file.file);
                formData.append("type", 'bankCardFrontPic');
                var toast = Toast.loading({
                    duration: 0,
                    message: '处理中',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$http
                    .post("/wechat/api.merchant/uploadMerchantImg", formData, {
                        headers: {"Content-Type": "multipart/form-data"}
                    })
                    .then(
                        function (res) {
                            console.log('res', res);
                            if (res && res.data.code == 200) {

                                //银行卡图片
                                this.form.accountInfo.bankCardFrontPic = res.data.path;

                                // 开户号
                                this.form.accountInfo.bankCardNo = res.data.data.card_num;
                                //结算人证件
                                this.form.accountInfo.idCardNo = this.form.legalPerson.idCardNo;

                                //更改本地图片地址(开户许可)
                                this.form.extData.img.merchant_img_permit_for_bank_account = res.data.local_img;

                                //更改本地图片地址(结算卡)
                                this.form.extData.img.merchant_img_bank_card = res.data.local_img;

                                //如果是 对私账户 法人结算
                                if (this.form.accountInfo.type == "1" && this.form.accountInfo.legalFlag == "1") {
                                    //户名为法人名称
                                    this.form.accountInfo.holder = this.form.legalPerson.legalName;
                                }

                                //toast删除和提示
                                toast.clear();
                                Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});
                            }
                        },
                        function (res) {
                            toast.clear();
                            Notify({type: 'primary', message: res.data.msg});
                        }
                    );
            },
            //日期格式化
            dateFormat(dateString) {
                var pattern = /(\d{4})(\d{2})(\d{2})/;
                return this.trim(dateString.replace(pattern, '$1-$2-$3'));
            },
            //清空前后空格
            trim(sValue){
                return sValue.replace(/(^\s*)|(\s*$)/g, "");
            },
            //获取省级别银行网点信息
            getProvinceBanks(level, city = '') {
                this.$http.get('/wechat/api.common/getLeshuazfBanks', {
                    params: {
                        level: level,
                        city: city
                    }
                }).then(function (response) {
                    console.log('response', response);
                    switch (level) {
                        case 1:
                            this.provinceBanks = response.data.data;
                            break;
                        case 2:
                            this.cityBanks = response.data.data;
                            break;
                        case 3:
                            break;
                    }

                });
            },
            //银行选中
            banksSelected(col) {
                console.log('col', col);
                this.showBanksPicker = false;
                this.banksVal = col.address;
                this.form.accountInfo.unionpay = col.banking;
            },
            //显示身份证有效期选择
            showIdCardEndPickerClick() {
                if (!this.isIdCardEnd) {
                    this.showIdCardEndPicker = true;
                }
            },
            //显示营业执照有效期选择
            showLicenseEndPickerClick() {
                if (!this.isLicenseEnd) {
                    this.showLicenseEndPicker = true;
                }
            },
            //导航栏左侧返回
            onClickLeft() {
                this.$router.push("/");
            },
            //获取初始化数据
            getOption(field) {
                this.$http.get('/wechat/api.common/getOption', {
                    params: {
                        field: field
                    }
                }).then(function (response) {
                    console.log('response', response);
                    this[field] = response.data.data;
                });
            },

            //获取当前业务员微信openid的信息
            getAgentSalesmanByOpenId(openid) {
                const that = this;
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$http.get('/wechat/api.common/getAgentSalesmanByOpenId', {params: {openid: openid}}).then(function (response) {
                    Toast.clear();
                    if (response.data.code != 200) {
                        Dialog.alert({
                            title: '提示',
                            message: response.data.msg,
                        }).then(() => {
                            that.$router.push("/SalesmanBind");
                        });
                    }
                    console.log('response', response);
                })
            },
            //获取微信js
            getWechatJs() {
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$http.post('/wechat/api.common/getWechatJs', {
                    url: window.location.href
                }).then(function (response) {
                    Toast.clear();
                    console.log('response', response);
                    if (response.data && response.data.code == 200) {
                        wx.config(JSON.parse(response.data.data));
                    }
                })
            },
            //通用图片上传处理
            openPhoto(field) {

                var that = this;
                wx.chooseImage({
                    // 默认9
                    count: 1,
                    // 可以指定是原图还是压缩图，默认二者都有
                    sizeType: ['original', 'compressed'],
                    // 可以指定来源是相册还是相机，默认二者都有
                    sourceType: ['album', 'camera'],
                    success: function (res) {
                        var toast = Toast.loading({
                            duration: 0,
                            message: '处理中',
                            forbidClick: true,
                            loadingType: 'spinner',
                        });
                        wx.getLocalImgData({
                            localId: res.localIds[0], // 图片的localID
                            success: function (resData) {

                                var localData = resData.localData;
                                if (localData.indexOf('data:image') != 0) {
                                    //判断是否有这样的头部
                                    localData = 'data:image/jpeg;base64,' + localData
                                }
                                localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg');


                                //alert(JSON.stringify(res));
                                //传递数据
                                that.$http.post('/wechat/api.merchant/uploadMerchantImg',
                                    {
                                        'localId': res.localIds[0],
                                        'type': field,
                                        'localData': localData
                                    }
                                ).then(response => {
                                    toast.clear();
                                    switch (field) {
                                        case 'licensePic':
                                            Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});

                                            //赋值图片
                                            that.imgs.licensePic = Config.baseURL + response.data.local_img;
                                            //商户全称
                                            that.form.baseInfo.merchantName = response.data.data.name;
                                            //营业执照名称
                                            that.form.licenseInfo.licenseFullName = response.data.data.name;
                                            //营业执照编号
                                            that.form.licenseInfo.license = response.data.data.reg_num;
                                            //营业执照地址
                                            that.form.licenseInfo.licenseAddress = response.data.data.address;
                                            //开始日期
                                            that.form.licenseInfo.licenseStart = that.dateFormat(response.data.data.establish_date);
                                            //营业执照图片赋值
                                            that.form.licenseInfo.licensePic = response.data.path;

                                            //更改本地图片地址
                                            that.form.extData.img.merchant_img_electronic_business_license = response.data.local_img;

                                            var licenseEnd = that.dateFormat(response.data.data.valid_period);
                                            if (licenseEnd == "2999-12-31") {
                                                //结束日期
                                                that.form.licenseInfo.licenseEnd = '长期';
                                                //选中长期按钮
                                                that.isLicenseEnd = true;
                                            } else {
                                                //结束日期
                                                that.form.licenseInfo.licenseEnd = licenseEnd;
                                            }
                                            break;
                                        case 'idcardFrontPic':
                                            //赋值图片
                                            that.imgs.idcardFrontPic = Config.baseURL + response.data.local_img;
                                            //法人姓名
                                            that.form.legalPerson.legalName = response.data.data.name;
                                            //联系人为法人
                                            that.form.contactInfo.name = response.data.data.name;
                                            //法人证件号
                                            that.form.legalPerson.idCardNo = response.data.data.num;
                                            //法人身份证正面地址
                                            that.form.legalPerson.idcardFrontPic = response.data.path;

                                            //更改本地图片地址(法人身份证正面)
                                            that.form.extData.img.merchant_img_corporate_id_card_front = response.data.local_img;

                                            //更改本地图片地址
                                            that.form.extData.img.merchant_img_electronic_business_license = response.data.local_img;

                                            toast.clear();
                                            Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});
                                            break;
                                        case 'idcardBackPic':
// 身份证开始日期
                                            that.form.legalPerson.idCardStart = that.dateFormat(response.data.data.start_date);
                                            //赋值图片
                                            that.imgs.idcardBackPic = Config.baseURL + response.data.local_img;
                                            //身份证结束日期
                                            var idCardEndData = that.dateFormat(response.data.data.end_date);
                                            //法人身份证正面地址
                                            that.form.legalPerson.idcardBackPic = response.data.path;

                                            //更改本地图片地址(法人身份证反面)
                                            that.form.extData.img.merchant_img_corporate_id_card_obverse = response.data.local_img;

                                            if (idCardEndData == "长期") {
                                                //选中长期按钮
                                                that.isIdCardEnd = true;
                                                console.log("isIdCardEnd", that.isIdCardEnd);
                                            }
                                            // 身份证结束日期
                                            that.form.legalPerson.idCardEnd = that.dateFormat(response.data.data.end_date);
                                            //toast删除和提示
                                            toast.clear();
                                            Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});
                                            break;
                                        case 'bankCardFrontPic':
                                            //赋值图片
                                            that.imgs.bankCardFrontPic = Config.baseURL + response.data.local_img;
                                            //银行卡图片
                                            that.form.accountInfo.bankCardFrontPic = response.data.path;

                                            // 开户号
                                            that.form.accountInfo.bankCardNo = response.data.data.card_num;
                                            //结算人证件
                                            that.form.accountInfo.idCardNo = that.form.legalPerson.idCardNo;

                                            //更改本地图片地址(开户许可)
                                            that.form.extData.img.merchant_img_permit_for_bank_account = response.data.local_img;

                                            //更改本地图片地址(结算卡)
                                            that.form.extData.img.merchant_img_bank_card = response.data.local_img;

                                            //如果是 对私账户 法人结算
                                            if (that.form.accountInfo.type == "1" && that.form.accountInfo.legalFlag == "1") {
                                                //户名为法人名称
                                                that.form.accountInfo.holder = that.form.legalPerson.legalName;
                                            }

                                            //toast删除和提示
                                            toast.clear();
                                            Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});
                                            break;
                                        case 'doorPic':
                                            //赋值图片
                                            that.imgs.doorPic = Config.baseURL + response.data.local_img;
                                            that.form.shopInfo.doorPic = response.data.path;
                                            //更改本地图片地址(门头照)
                                            that.form.extData.img.merchant_img_door_shot = response.data.local_img;
                                            break;
                                        case 'insidePic':
                                            //赋值图片
                                            that.imgs.insidePic = Config.baseURL + response.data.local_img;
                                            that.form.shopInfo.insidePic = response.data.path;
                                            //更改本地图片地址(室内景)
                                            that.form.extData.img.merchant_img_shop_interior = response.data.local_img;
                                            break;
                                        case 'cashierDeskPic':
                                            //赋值图片
                                            that.imgs.cashierDeskPic = Config.baseURL + response.data.local_img;
                                            that.form.shopInfo.cashierDeskPic = response.data.path;
                                            //更改本地图片地址(收银台)
                                            that.form.extData.img.merchant_img_checkout_counter = response.data.local_img;
                                            break;
                                        case 'nonLegSettleAuthPic':
                                            //赋值图片
                                            that.imgs.nonLegSettleAuthPic = Config.baseURL + response.data.local_img;
                                            //结算授权申请书
                                            that.form.accountInfo.nonLegSettleAuthPic = response.data.path;
                                            //更改本地图片地址(结算授权书)
                                            that.form.extData.img.merchant_img_authorization_statement = response.data.local_img;
                                            break;
                                        case 'nonLegIdcardFrontPic':
                                            //赋值图片
                                            that.imgs.nonLegIdcardFrontPic = Config.baseURL + response.data.local_img;
                                            //非法人身份证人像面
                                            that.form.accountInfo.nonLegIdcardFrontPic = res.data.path;
                                            //更改本地图片地址(负责人正面)
                                            that.form.extData.img.merchant_img_principal_id_card_front = response.data.local_img;
                                            break;
                                        case 'nonLegIdcardBackPic':
                                            //赋值图片
                                            that.imgs.nonLegIdcardBackPic = Config.baseURL + response.data.local_img;
                                            //非法人身份证国徽面
                                            that.form.accountInfo.nonLegIdcardBackPic = res.data.path;
                                            //更改本地图片地址(负责人反面)
                                            that.form.extData.img.merchant_img_principal_id_card_obverse = response.data.local_img;
                                            break;
                                            //法人手持证件照
                                        case 'merchant_img_legal_holding_id_photo':
                                            //赋值图片
                                            that.imgs.merchant_img_legal_holding_id_photo = Config.baseURL + response.data.local_img;
                                            //更改本地图片地址(法人手持证件照)
                                            that.form.extData.img.merchant_img_legal_holding_id_photo = response.data.local_img;
                                            break;
                                        //负责人手持银行卡
                                        case 'merchant_img_holding_bank_card':
                                            //赋值图片
                                            that.imgs.merchant_img_holding_bank_card = Config.baseURL + response.data.local_img;
                                            //更改本地图片地址(法人手持证件照)
                                            that.form.extData.img.merchant_img_holding_bank_card = response.data.local_img;
                                            break;
                                        //负责人手持证件照
                                        case 'merchant_img_holding_photo':
                                            //赋值图片
                                            that.imgs.merchant_img_holding_photo = Config.baseURL + response.data.local_img;
                                            //更改本地图片地址(法人手持证件照)

                                            that.form.extData.img.merchant_img_holding_photo = response.data.local_img;
                                            break;
                                        //负责人身份证正面
                                        case 'merchant_img_principal_id_card_front':
                                            //赋值图片
                                            that.imgs.merchant_img_principal_id_card_front = Config.baseURL + response.data.local_img;
                                            //更改本地图片地址(法人手持证件照)
                                            that.form.extData.img.merchant_img_principal_id_card_front = response.data.local_img;
                                            break;
                                        //负责人身份正反面
                                        case 'merchant_img_principal_id_card_obverse':
                                            //赋值图片
                                            that.imgs.merchant_img_principal_id_card_obverse = Config.baseURL + response.data.local_img;
                                            //更改本地图片地址(法人手持证件照)
                                            that.form.extData.img.merchant_img_principal_id_card_obverse = response.data.local_img;
                                            break;
                                        default:
                                            break;
                                    }

                                }).catch(err => {
                                    console.error("err", err);
                                });


                            }
                        });
                    }
                });

            }
        },
        created() {

            console.log('this.$route.params', this.$route.params);
            console.log('this.$route.query', this.$route.query);
            var pay_code = this.$route.query.pay_code;
            if (this.$route.query.pay_code) {
                this.form.extData.payCode = pay_code;
                VueCookie.set('payCode', pay_code);
            } else {
                var payCode = VueCookie.get('payCode');
                if (payCode) {
                    this.form.extData.payCode = payCode;
                } else {
                    Dialog.alert({
                        title: '提示',
                        message: '支付码未获取成功，请重新扫码',
                    }).then(() => {
                    });
                }
            }


            var openid = VueCookie.get('openid');
            this.form.extData.openid = openid;
            //this.getAgentSalesmanByOpenId(openid);
            this.getWechatJs();
            // console.log('LeshuazfMcc', LeshuazfMcc);
            //获取省级别银行网点信息
            this.getProvinceBanks(1);
            this.getOption('merchantType');
            this.getOption('credentialType');
            this.getOption('type');
            this.getOption('legalFlag');
            this.getOption('settleTo');


        },
        watch: {
            //银行选择值
            banksValue(val) {
                this.$http.get('/wechat/api.common/searchLeshuazfBanks', {
                    params: {
                        province: this.provinceBanksVal,
                        city: this.cityBanksVal,
                        banks_text: val
                    }
                }).then(function (response) {
                    console.log('response', response);
                    this.banksData = response.data.data;
                });

            },
            //监听是否标记身份证结束日期
            isIdCardEnd(val) {
                if (val) {
                    this.form.legalPerson.idCardEnd = '长期'
                } else {
                    this.form.legalPerson.idCardEnd = '';
                }
            },
            //监听是否标记营业执照结束日期
            isLicenseEnd(val) {
                if (val) {
                    this.form.licenseInfo.licenseEnd = '长期'
                } else {
                    this.form.licenseInfo.licenseEnd = '';
                }
            }
        }
    }
</script>

<style>
    .van-collapse-item__content {
        padding: 0 !important;
    }

    .form_box {
        margin-top: 50px
    }

    body {
        background: #f5f5f5
    }

    .pay_code {
        margin-bottom: 0.1rem;
    }

    .photo {
        width: 12vh;
        height: 12vh;
    }
</style>
